import React, { useRef, useState, useEffect } from "react";
import playIcon from "../assets/images/play.png";
import pauseIcon from "../assets/images/pause.png";
import volumeIcon from "../assets/images/volume-high.png";
import muteIcon from "../assets/images/volume-cross.png";
import fullscreenIcon from "../assets/images/expand.png"; // Add a fullscreen icon if needed

const Video = ({ src, poster }) => {
  const videoRef = useRef(null); // Ref to control the video element
  const [isPlaying, setIsPlaying] = useState(false); // Track play/pause state
  const [isMuted, setIsMuted] = useState(false); // Track mute/unmute state

  // Handle video play/pause toggle
  const togglePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  // Handle mute/unmute toggle
  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  // Handle fullscreen toggle
  const makeFullscreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen(); // Standard fullscreen API
      } else if (videoRef.current.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen(); // Safari
      } else if (videoRef.current.mozRequestFullScreen) {
        videoRef.current.mozRequestFullScreen(); // Firefox
      } else if (videoRef.current.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen(); // IE/Edge
      }
    }
  };

  // Automatically play the video after loading
  useEffect(() => {
    if (videoRef.current && isPlaying) {
      videoRef.current.play();
    }
  }, [isPlaying]);

  return (
    <div className="videoContainer">
      <p data-aos="fade-up" data-aos-duration="2000">
        ویدیو معرفی محصول
      </p>
      <h1 className="videoTitle" data-aos="fade-up" data-aos-duration="2000">
        یخچال فریزر پاکشوما سری Twin Peaks
      </h1>
      <div className="cardContainer">
        <div className="card">
          <video
            ref={videoRef}
            src={src}
            alt="video"
            controls={false}
            poster={poster}
            preload="auto" // Preload video to start fetching data when possible
          />
          {/* Custom Video Controls */}
          <div className="videoControls">
            {/* Fullscreen Button */}
            <div className="buttonIcon">
              <img
                src={fullscreenIcon}
                alt="fullscreen icon"
                onClick={makeFullscreen} // Call makeFullscreen on click
                style={{ cursor: "pointer", width: "24px", height: "24px" }}
                aria-label="Fullscreen" // Add accessibility for fullscreen button
              />
            </div>

            {/* Volume Button */}
            <div className="buttonIcon">
              <img
                src={isMuted ? muteIcon : volumeIcon}
                alt={isMuted ? "Mute" : "Unmute"}
                onClick={toggleMute} // Call toggleMute on click
                style={{ cursor: "pointer" }}
                aria-label={isMuted ? "Unmute" : "Mute"} // Add accessibility for volume button
              />
            </div>

            {/* Play/Pause Button */}
            <div className="buttonIcon">
              <img
                src={isPlaying ? pauseIcon : playIcon}
                alt={isPlaying ? "Pause" : "Play"}
                onClick={togglePlay} // Call togglePlay on click
                style={{ cursor: "pointer" }}
                aria-label={isPlaying ? "Pause" : "Play"} // Add accessibility for play/pause button
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
